import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Question, User } from "@phosphor-icons/react";
import MultiRoleImpersonateWidget from "@/components/MultiRoleImpersonateWidget";
import { useAuth } from "@/context/AuthContext";
import { helpSlugFor, visibleSlugs } from "@/lib/helpRoutes";

export function HowToLink({ user, className = "", testId = "how-to-link" }) {
  const { pathname } = useLocation();
  const slug = helpSlugFor(pathname, user);
  const [ok, setOk] = useState(false);
  useEffect(() => {
    setOk(false);
    if (slug) { visibleSlugs(user?.id).then((s) => setOk(s.has(slug))); }
  }, [slug, user?.id]);
  if (!slug || !ok) return null;
  return (
    <Link to={`/help?slug=${slug}`} data-testid={testId}
      className={`flex items-center gap-2 px-3 py-1.5 border border-black bg-yellow-50 hover:bg-black hover:text-white transition-colors duration-100 text-xs uppercase tracking-widest whitespace-nowrap ${className}`}>
      <Question size={14} weight="bold" /> <span className="hidden sm:inline">How do I use this?</span><span className="sm:hidden">Help</span>
    </Link>
  );
}

/**
 * Top bar shown above main content. Displays scope (internal/client/affiliate)
 * and a profile shortcut.
 */
export default function TopBar({ user, org }) {
  const { refresh } = useAuth();
  const scopeLabel =
    user?.org_type === "internal"
      ? "INTERNAL OPS"
      : user?.org_type === "client"
      ? `CLIENT · ${org?.name || ""}`
      : `AFFILIATE · ${org?.name || ""}`;

  return (
    <header className="border-b border-black bg-white flex items-center justify-between gap-2 px-3 sm:px-6 py-3">
      <div className="min-w-0 flex-1">
        <div className="label-mono truncate">{scopeLabel}</div>
        <div className="text-sm font-semibold truncate">{org ? org.name : "System"}</div>
      </div>
      <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
        {/* Iter-71: super_admin-only shortcut to impersonate any seeded test account. */}
        <MultiRoleImpersonateWidget user={user} refresh={refresh} />
        <HowToLink user={user} />
        <NavLink
          to="/profile"
          data-testid="nav-profile"
          aria-label="Profile"
          className="flex items-center gap-2 px-3 py-1.5 border border-black hover:bg-black hover:text-white transition-colors duration-100 text-xs uppercase tracking-widest"
        >
          <User size={14} weight="bold" /> <span className="hidden sm:inline">Profile</span>
        </NavLink>
      </div>
    </header>
  );
}
